export const getParticipants = (teams) => {
  const participants = [];
  for (const team of teams) {
    team.participants.forEach((participant) => {
      participants.push(participant);
    });
  }
  return participants;
};
